module.exports = function() {
  return new Worker(__webpack_public_path__ + "f309ce549990ee1f1106.worker.js");
};